export enum FormatTypeBool {
    tf = 1,
    yn = 2,
    oo = 3,
    icon = 4
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/models/format-type-bool.model.ts